module.exports = __webpack_public_path__ + "img/Device-VisitorRegistration.62ab6a36.png";